import { render } from "./CookiePolicyContent.vue?vue&type=template&id=4a0dc51f"
import script from "./CookiePolicyContent.vue?vue&type=script&lang=js"
export * from "./CookiePolicyContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__